module.exports = __webpack_public_path__ + "static/img/four.5bcc6e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinDupLeImg/four.png
// module id = qIb1
// module chunks = 1